import { useTranslation, Trans } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { LazyImage, ImageContainer } from './ImageContainer';
import styled from 'styled-components';
import { QuoteRequestButton } from './QuoteRequestButton';
import Victor from '../media/photos/Victor.jpg';
import Valentin from '../media/photos/Valentin.jpg';
import VictorBlur from '../media/photos/Victor_blur.jpg';
import ValentinBlur from '../media/photos/Valentin_blur.jpg';
import React, { HTMLAttributes } from 'react';
import {CardText} from "./CardText";
import {StyledHeader} from "./GeneralText";


type HomeProps = {
    handleClick?: () => void;
};
export function Home({ handleClick }: HomeProps) {
  const { t } = useTranslation(namespaces.common);

  return (
    <Wrapper id={t("nav/home")}>
      <PageTitle>{t("__Statement__")}</PageTitle>

      <Description1>{t("__Descrizione_chi_siamo_p1__")}</Description1>
      <Description2>{t("__Descrizione_chi_siamo_p2__")}</Description2>

      <ImageContainer1 $noMargin={true}>
        <LazyImage src={Victor} placeholderSrc={VictorBlur} alt="Victor" />
      </ImageContainer1>
      <ImageContainer2 $noMargin={true}>
        <LazyImage src={Valentin} placeholderSrc={ValentinBlur} alt="Valentin" />
      </ImageContainer2>

      <ButtonContainer>
        <QuoteRequestButton handleClick={handleClick} />
      </ButtonContainer>
    </Wrapper >
  )
}

const Wrapper = styled.div<HTMLAttributes<HTMLDivElement>>`
  grid-column: 2 / -2;
  margin-block: 3em;
  scroll-margin-top: 4em;
  display: grid;
  gap: var(--gap);
  align-content: space-evenly;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas:
    "header header"
    "description-1 description-2"
    "victor valentin"
    "cta cta";

  @media (max-width: 1200px) {
    margin-top: 1em;
    grid-template-rows: auto;
    grid-template-areas:
      "header header"
      "description-1 description-1"
      "description-2 description-2"
      "victor valentin"
      "cta cta";
`;
const PageTitle = styled(StyledHeader)`
  font-size: clamp(1.5rem, 2vw + 1rem, 3rem);
  font-weight: 400;
  color: var(--color-text);
  grid-area: header;
  display: inline-block;
  line-height: 1.4em;
  margin-bottom: 1rem;

  @media (max-width: 1200px) {
    padding: 0.5em;
    margin: 0 0.5em;
  }
`;
const Description1 = styled(CardText)`
  grid-area: description-1;
`;
const Description2 = styled(CardText)`
  grid-area: description-2;
`;
const ImageContainer1 = styled(ImageContainer)`
  grid-area: victor;
`;
const ImageContainer2 = styled(ImageContainer)`
  grid-area: valentin;
`;
const ButtonContainer = styled.div`
  grid-area: cta;
  align-self: center;
`;